import { useEffect, useState } from "react";
import { readApiErrorType, resolveApiErrorMessageId, } from "../utils/httpErrors";
/**
 * Translation id of the message for a failed request: the generic message of
 * its backend error type when there is one (e.g. -92, a filter refused for the
 * public-only view), otherwise the screen's own fallback.
 *
 * @param error the request error; `null`/`undefined` while there is none
 * @param fallbackId translation id shown for any other failure
 * @returns the translation id to show
 */
export var useApiErrorMessageId = function (error, fallbackId) {
    var _a = useState(fallbackId), messageId = _a[0], setMessageId = _a[1];
    useEffect(function () {
        setMessageId(fallbackId);
        if (!error)
            return undefined;
        var cancelled = false;
        readApiErrorType(error).then(function (type) {
            var _a;
            if (!cancelled) {
                setMessageId((_a = resolveApiErrorMessageId(type)) !== null && _a !== void 0 ? _a : fallbackId);
            }
        });
        return function () {
            cancelled = true;
        };
    }, [error, fallbackId]);
    return messageId;
};
